import type { ReactElement } from 'react'
import styles from './SkeletonRouteCard.module.css'

/**
 * Loading-state skeleton for one route variant (Figma spec §1.8). Frame
 * w 140, padding 8, gap 8, r 8, **1px full-opacity `text/secondary`
 * border** (spec Drift #3 — not @0.3). Three `bg/secondary` bars (r 4):
 * 60×16, 90×12, 50×12.
 *
 * Shimmer is runtime via CSS `@keyframes` (same convention as
 * StationCard V2 Loading); under `prefers-reduced-motion: reduce` (the
 * Playwright default) the bars render static for deterministic snapshots.
 */
export function SkeletonRouteCard(): ReactElement {
  return (
    <div className={styles.card} data-testid="skeleton-route-card" aria-hidden="true">
      <span className={`${styles.bar} ${styles.bar60}`} />
      <span className={`${styles.bar} ${styles.bar90}`} />
      <span className={`${styles.bar} ${styles.bar50}`} />
    </div>
  )
}
